import React, { useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import Blog from "../../../../../component/blog";
import ErrorLabel from "../../../../../component/error_label";
import Newsletter from "../../../../../component/newsletter";
import OurApp from "../../../../../component/our_app";
import RecommendedPolicy from "../../../../../component/recommended_policy";
import { useDropzone } from "react-dropzone";
import $ from "jquery";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import {
  actionDropdown,
  resetDropdownDataResponse,
} from "../../../../../common/store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";
import toast, { LoaderIcon } from "react-hot-toast";
import { actionIntimateClaim, resetIntimateClaimResponse } from "../store";
import UploadDocuments from "../upload_doc";
import ClaimDetail from "../claim_detail_popup";
import Loader from "../../../../../component/page_loader";
import Contact from "../../../../../component/contact";
import { actionClaimAdd } from "../../forms/store";
import { numberWheelChange } from "../../../../../utils";

const IntimateClaim = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { dropdownData } = useSelector((state) => ({
    ...state.commonStore,
  }));

  const { intimateClaim } = useSelector((state) => ({
    ...state.claimStore,
  }));

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    setValue,
    watch,
    control,
  } = useForm({
    defaultValues: {
      is_active: false,
    },
  });

  const [allDropdownArr, setAllDropdownArr] = useState({
    loss_type: ["Accident", "AOG Peril", "Others"],
  });
  const [isUploadDoc, setIsUploadDoc] = useState(false);
  const [intimateclaimObj, setIntimateClaimObj] = useState(null);
  const [isDisplayClaimDetail, setIsDisplayClaimDetail] = useState(false);
  const [claimDetailObj, setClaimDetailObj] = useState(null);
  const [isLoader, setLoader] = useState(false);
  const [isAfter, setIsAfter] = useState();
  const [policyExpiryDate, setPolicyExpiryDate] = useState();

  useEffect(() => {
    if (location?.state.data) {
      setPolicyExpiryDate(location?.state?.data?.policy_expiry_date);
      const isPolicyExpired = moment(
        location?.state?.data?.policy_expiry_date
      ).isAfter(moment().add(7, "days"));
      setIsAfter(isPolicyExpired);
      setValue("policy_no", location?.state?.data.policy_no);
      setValue("insured_name", location?.state?.data.insured_name);
      setValue("policy_type", location?.state?.data.policy_type);
      // setValue("rm_name", location?.state?.data.rm_name);
      // setValue("department_name", location?.state?.data.department_name);
    }
  }, [location]);

  const initialRender = () => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setValue("contact_person_name", userData.full_name);
      setValue("contact_person_mobile_number", userData.mobile);
    }
  };
  useEffect(() => {
    initialRender();
  }, []);

  useEffect(() => {
    if (intimateClaim !== null) {
      dispatch(resetIntimateClaimResponse())
      if (intimateClaim.status === true) {
        setLoader(false);
        setIntimateClaimObj(intimateClaim.data);
        setIsUploadDoc(true);
        toast.success(intimateClaim.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR
          }
        })
        navigate("/claim");
      } else {
        switch (intimateClaim.status_code) {
          case 400:
            toast.error(intimateClaim.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
          default:
        }
      }
    }
  }, [intimateClaim]);

  useEffect(() => {
    if (dropdownData !== null) {
      dispatch(resetDropdownDataResponse());
      if (dropdownData.result === true) {
        // setValue('allDropdownArr', dropdownData.data)
        setAllDropdownArr(dropdownData?.data);
      } else {
        switch (dropdownData.status_code) {
          default:
        }
      }
    }
  }, [dropdownData]);

  const generateLossType = () => {
    var menu = [];
    if (allDropdownArr != null && allDropdownArr.loss_type?.length > 0) {
      allDropdownArr.loss_type.forEach(function (child, labelIndex) {
        menu.push(
          <option key={labelIndex} value={child}>
            {child}
          </option>
        );
      });
    }
    return menu;
  };

  const onSubmit = async (data) => {
    data.policy_id = location?.state?.data.id;
    // data.control_no = location?.state?.data.control_no;
    data.policy_no = location?.state?.data.policy_no;
    data.insured_name = data.insured_name;
    data.policy_type = data.policy_type;
    data.date_of_loss = data.date_of_loss;
    data.claim_type = data.claim_type;
    data.nature_of_claim = data.nature_of_claim;
    data.loss_amount = data.loss_amount;
    data.loss_details = data.loss_details;
    data.loss_location = data.loss_location;
    data.contact_person_name = data.contact_person_name;
    data.contact_person_mobile_number = data.contact_person_mobile_number;
    data.alternate_contact_person_name = data.alternate_contact_person_name;
    data.alternate_contact_person_mobile_number = data.alternate_contact_person_mobile_number;
    data.alternate_contact_person_email = data.alternate_contact_person_email;
    data.final_intimation_date = moment().format('DD/MM/YYYY')

    var input = { ...data };
    var files = [];
    if (data.documents != null) {
      files.push({
        name: "file",
        value: data.documents[0],
      });
    }
    // dispatch(actionIntimateClaim({
    //   input, files 
    // }))
    delete data.documents;
    setClaimDetailObj({ input, files });
    setIsDisplayClaimDetail(true);
  };

  return (
    <>
      {isLoader === true ? <Loader /> : <></>}

      <div className="row pt-2 pb-5">
        <div className="col-12">
          <nav className="--bs-breadcrumb-divider" aria-label="breadcrumb">
            <ol className="breadcrumb">
              {/* <li className="breadcrumb-item">
                <a
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                >
                  Dashboard
                </a>
              </li> */}
              <li className="breadcrumb-item active" aria-current="page">
                Intimate Claim
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-12 col-md-9">
          <div class="mt-4 row justify-content-between tab-menu">
            <div class="col-12 col-md-4">
              <a  class="btn btn-light btn-sm mx-2 fw-bold my-auto">
                Intimate Claim
              </a>
            </div>
            {/* <div class="col-12 col-md-8 text-end">
                                    <button href="#" class="btn btn-light btn-sm active  " aria-current="page"> Show Policy Detail </button>
                                    <button href="#" class="btn btn-warning btn-sm "> View All Policies </button>
                                </div> */}
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <form
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4 col-12 mb-2">
                        <label for="policy_no" class="form-label">
                          Policy Number
                        </label>
                        <input
                          type="text"
                          disabled
                          class="form-control"
                          id="policy_no"
                          {...register("policy_no", {
                            required: "This is required.",
                            minLength: {
                              value: 6,
                              message:
                                " Policy No cannot be less than 6-chars.",
                            },
                            maxLength: {
                              value: 30,
                              message:
                                " Policy No cannot be greater than 30-chars.",
                            },
                          })}
                        />
                        {errors.policy_no && (
                          <ErrorLabel message={errors.policy_no?.message} />
                        )}
                      </div>
                      <div class="col-md-4 col-12 mb-2">
                        <label for="insured_name" class="form-label">
                          Name Of Insured
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="insured_name"
                          {...register("insured_name")}
                          disabled
                        />
                      </div>
                      <div class="col-md-4 col-12 mb-2">
                        <label for="policy_type" class="form-label">
                          Type Of Policy
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="policy_type"
                          {...register("policy_type")}
                          disabled
                        />
                      </div>
                      <div class="col-md-4 col-12 mb-2">
                        <div class="form-group has-search">
                          <label for="querytype" class="form-label">
                            Date of Loss<span class="text-danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="date_of_loss"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "date_of_loss",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  minDate: new Date().fp_incr(-6),
                                  // maxDate:
                                  //   moment(policyExpiryDate).format(
                                  //     "DD-MM-YYYY"
                                  //   ),
                                  maxDate: moment(policyExpiryDate).isAfter(moment()) ? new Date() : moment(policyExpiryDate).toDate(),
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.date_of_loss && (
                            <ErrorLabel
                              message={errors.date_of_loss?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div class="col-md-4 col-12 mb-2">
                        <label for="claimType" class="form-label">
                          Claim Type
                        </label>
                        <select
                          id="claim_type"
                          className="form-control form-select"
                          {...register("claim_type", {
                            required: "This is required.",
                          })}
                        >
                          <option value="">Select Claim Type</option>
                          <option value="OD Damages">OD Damages</option>
                          <option value="Third Party Claim">
                            Third Party Claim
                          </option>
                          <option value="Theft Claim">Theft Claim</option>
                          <option value="Other">Other</option>
                        </select>
                        {errors.claim_type && (
                          <ErrorLabel message={errors.claim_type?.message} />
                        )}
                      </div>
                      <div class="col-md-4 mb-2">
                        {/* (Nature of Claim) */}
                        <label for="nature_of_claim" class="form-label">
                          Type Of Loss <span class="text-danger">*</span>
                        </label>
                        <select
                          id="nature_of_claim"
                          className="form-control form-select"
                          {...register("nature_of_claim", {
                            required: "This is required.",
                          })}
                        >
                          <option value="">Select </option>
                          {generateLossType()}
                        </select>
                        {errors.nature_of_claim && (
                          <ErrorLabel
                            message={errors.nature_of_claim?.message}
                          />
                        )}
                        {/* END: Nature of Claim */}
                      </div>
                      <div class="col-md-4 col-12 mb-2">
                        {/* Estimate Loss Amount */}
                        <label for="loss_amount" class="form-label">
                          Claim Amount <span class="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          onFocus={numberWheelChange}
                          class="form-control"
                          id="loss_amount"
                          {...register("loss_amount", {
                            required: "This is required.",
                          })}
                        />
                        {errors.loss_amount && (
                          <ErrorLabel message={errors.loss_amount?.message} />
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div class="col-12 col-md-6 mb-2">
                        <label for="loss_details" class="form-label">
                          Claim Description (Loss Details){" "}
                          <span class="text-danger">*</span>
                        </label>
                        <textarea
                          class="form-control"
                          id="loss_details"
                          rows="3"
                          {...register("loss_details", {
                            required: "This is required.",
                          })}
                        ></textarea>
                        {errors.loss_details && (
                          <ErrorLabel message={errors.loss_details?.message} />
                        )}
                      </div>
                      <div class="col-12 col-md-6 mb-2">
                        <label for="loss_location" class="form-label">
                          Loss Location<span class="text-danger">*</span>
                        </label>
                        <textarea
                          class="form-control"
                          id="loss_location"
                          rows="3"
                          {...register("loss_location", {
                            required: "This is required.",
                          })}
                        ></textarea>
                        {errors.loss_location && (
                          <ErrorLabel message={errors.loss_location?.message} />
                        )}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div class="col-md-4 mb-2">
                        <label for="contact_person_name" class="form-label">
                          Loss Site Contact Person Name
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="contact_person_name"
                          {...register("contact_person_name", {
                            required: "This is required.",
                          })}
                        />
                        {errors.contact_person_name && (
                          <ErrorLabel
                            message={errors.contact_person_name?.message}
                          />
                        )}
                      </div>
                      <div class="col-md-4 mb-2">
                        <label
                          for="contact_person_mobile_number"
                          class="form-label"
                        >
                          Loss Site Contact Person Mobile Number
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          min={0}
                          id="contact_person_mobile_number"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register("contact_person_mobile_number", {
                            required: "This is required.",
                            pattern: {
                              value: /^[6789]\d{9}$/,
                              message:
                                "Please enter a valid 10-digit mobile number",
                            },
                          })}
                        />
                        {errors.contact_person_mobile_number && (
                          <ErrorLabel
                            message={
                              errors.contact_person_mobile_number?.message
                            }
                          />
                        )}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div class="col-md-4 mb-2">
                        <label
                          for="alternate_contact_person_name"
                          class="form-label"
                        >
                          Alternate Contact Person Name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="alternate_contact_person_name"
                          {...register("alternate_contact_person_name")}
                        />
                        {errors.alternate_contact_person_name && (
                          <ErrorLabel
                            message={
                              errors.alternate_contact_person_name?.message
                            }
                          />
                        )}
                      </div>
                      <div class="col-md-4 mb-2">
                        <label
                          for="alternate_contact_person_mobile_number"
                          class="form-label"
                        >
                          Alternate Contact Person Number
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          min={0}
                          id="alternate_contact_person_mobile_number"
                          onInput={(e) => {
                            if (e.target.value.length > 10) {
                              e.target.value = e.target.value.slice(0, 10);
                            }
                          }}
                          {...register(
                            "alternate_contact_person_mobile_number",
                            {
                              pattern: {
                                value: /^[6789]\d{9}$/,
                                message:
                                  "Please enter a valid 10-digit mobile number",
                              },
                            }
                          )}
                        />
                        {errors.alternate_contact_person_mobile_number && (
                          <ErrorLabel
                            message={
                              errors.alternate_contact_person_mobile_number
                                ?.message
                            }
                          />
                        )}
                      </div>
                      <div class="col-md-4 mb-2">
                        <label
                          for="alternate_contact_person_email"
                          class="form-label"
                        >
                          Alternate Contact Person Email
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="alternate_contact_person_email"
                          {...register("alternate_contact_person_email", {
                            pattern: {
                              value:
                                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: "Enter valid Email Id.",
                            },
                          })}
                        />
                        {errors.alternate_contact_person_email && (
                          <ErrorLabel
                            message={
                              errors.alternate_contact_person_email?.message
                            }
                          />
                        )}
                      </div>
                      {/* <div class="col-md-4 mb-2">
                        <label for="insurer_contact_name" class="form-label">
                          Insurer Contact Name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="insurer_contact_name"
                          {...register("insurer_contact_name")}
                        />
                        {errors.insurer_contact_name && (
                          <ErrorLabel
                            message={errors.insurer_contact_name?.message}
                          />
                        )}
                      </div>
                      <div class="col-md-4 mb-2">
                        <label for="insurer_contact" class="form-label">
                          Insurer Contact Number
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          min={0}
                          {...register("insurer_contact", {
                            maxLength: {
                              value: 10,
                              message: "Mobile No. must be of 10-digits.",
                            },
                            minLength: {
                              value: 10,
                              message: "Mobile No. must be of 10-digits.",
                            },
                            pattern: {
                              value: /^[6789]\d{9}$/,
                              message:
                                " Mobile Number should start with 6, 7, 8 or 9",
                            },
                          })}
                        />
                        {errors.insurer_contact && (
                          <ErrorLabel
                            message={errors.insurer_contact?.message}
                          />
                        )}
                      </div>
                      <div class="col-md-4 mb-2">
                        <label for="insurer_contact_email" class="form-label">
                          Insurer Contact Email
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="insurer_contact_email"
                          {...register("insurer_contact_email", {
                            pattern: {
                              value:
                                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: "Enter valid Email Id.",
                            },
                          })}
                        />
                        {errors.insurer_contact_email && (
                          <ErrorLabel
                            message={errors.insurer_contact_email?.message}
                          />
                        )}
                      </div> */}
                    </div>
                    <div className="row bg-light  my-2">
                      <div className="col-md-6 mt-3">
                        <label htmlFor="file" className="form-label">
                          Attachment
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          accept=".gif,.png,.jpg,.doc,.docx,.pdf,.xlsx,.csv,.xls,.mp4,.avi,.mov"
                          id="documents"
                          name="documents"
                          {...register("documents", {
                            validate: {
                              lessThan20MB: (files) => {
                                let isValid = true;
                                for (let i = 0; i < files.length; i++) {
                                  if (files[i].size > 20971520) {
                                    isValid = false;
                                    break; // Exit loop if any file exceeds 20MB
                                  }
                                }
                                return (
                                  isValid || "Max size for each file is 20MB"
                                );
                              },
                            },
                          })}
                          multiple
                        />
                        {errors.documents && (
                          <ErrorLabel message={errors.documents?.message} />
                        )}
                      </div>
                      <div className="col-12 mt-3">
                        <small className="fs-7">
                          *only gif, png,jpg,doc,docx,pdf,xlsx,csv,xls images
                          allowed. Max size for image 5MB
                        </small>
                      </div>
                    </div>
                    <div>
                      <div class="col-12 mb-2 mt-3">
                        <button type="submit" class="btn btn-primary">
                          Submit
                        </button>
                        <button
                          type="btn"
                          class="btn btn-secondary"
                          style={{ marginLeft: 8 }}
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-3">
          {/* <RecommendedPolicy />
                    <Newsletter />
                    <Blog />
                    
                    <OurApp /> */}
          <Contact />
        </div>
      </div>

      {/* <UploadDocuments
        isUploadDoc={isUploadDoc}
        intimateclaimObj={intimateclaimObj}
        isUploadDocClose={() => {
          setIsUploadDoc(false);
          navigate("/claim");
          window.location.reload();
        }}
      /> */}
      <ClaimDetail
        isDisplayClaimDetail={isDisplayClaimDetail}
        claimDetailObj={claimDetailObj}
        isClaimDetailClose={({ data }) => {
          if (data === true) {
            setLoader(true);
            setIsDisplayClaimDetail(false);
            // Convert date_of_loss and final_intimation_date to YYYY-MM-DD format
            const formattedClaimDetailObj = {
              ...claimDetailObj,
              input: {
                ...claimDetailObj.input,
                date_of_loss: moment(claimDetailObj.input.date_of_loss, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                final_intimation_date: moment(claimDetailObj.input.final_intimation_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
              }
            };

            dispatch(
              actionIntimateClaim(formattedClaimDetailObj)
            );
          } else {
            setIsDisplayClaimDetail(false);
          }
        }}
      />
    </>
  );
};

export default IntimateClaim;
